import { FIELDS } from './constants';

const vendorFields = [
  {
    field: FIELDS.VENDOR_NAME,
    title: 'Company',
  },
  {
    field: FIELDS.CONTACT_NAME,
    title: 'Contact',
  },
  {
    field: FIELDS.CONTACT_PHONE,
    title: 'Phone',
  },
  {
    field: FIELDS.CONTACT_EMAIL,
    title: 'Email',
  },
];

export default vendorFields;
